// extracted by mini-css-extract-plugin
export var content = "_rn-1";
export var fullScreen = "_rn-0";